import { analytics } from '@/hooks/segment/useSegment'
import generatePageViewPropertiesForLocation, {
  PageViewProperties
} from './generatePageViewPropertiesForLocation'
import { Location } from '../../types/models/Location.model'
import { isNonEmptyString, isObject } from '@/utils/checks'
import { Center, PageType } from '@/types/models'
import {
  isCenterProfilePageType,
  isFacetPageType,
  isLocationPageType,
  isTaxonomyPageType
} from '@/domain/useCases/pageTypeCheck'
import generatePageViewPropertiesForCenter from './generatePageViewPropertiesForCenter'
import generatePageViewPropertiesForTerm from './generatePageViewPropertiesForTerm'
import { Term } from '@/types/models'
import generatePageViewPropertiesForFacetPage from './generatePageViewPropertiesForFacetPage'

export interface TrackPageViewProps {
  location?: Location
  center?: Center
  term?: Term
  pageType: PageType
}
interface TrackPageView {
  (props: TrackPageViewProps): void
}

const trackPageView: TrackPageView = ({ location, center, pageType, term }) => {
  let pageViewProps: PageViewProperties = {
    template: pageType
  }

  if (isObject(term) && isTaxonomyPageType(pageType)) {
    pageViewProps = generatePageViewPropertiesForTerm({ term })
  }

  if (isObject(center) && isCenterProfilePageType(pageType)) {
    pageViewProps = generatePageViewPropertiesForCenter({ center })
  }

  if (isObject(location) && isLocationPageType(pageType)) {
    pageViewProps = generatePageViewPropertiesForLocation({
      location,
      pageType
    })
  }

  if (isObject(location) && isObject(term) && isFacetPageType(pageType)) {
    pageViewProps = generatePageViewPropertiesForFacetPage({
      location,
      pageType,
      term
    })
  }

  analytics.page(pageViewProps)
}

export default trackPageView
